import { useContext, useEffect, useMemo, useState } from 'react'

import {
  BabyVaccineCardEmbed,
  useHealthToolsCache,
} from '@hhgtech/hhg-components'
import { BoxProps } from '@mantine/core'
import { formatBabyVaccinationContent } from 'api/dataTransform'
import { PATHS } from 'api/paths'
import {
  callApi,
  getApiPath,
  redirectToSSOWithReturnUrl,
  formatGenderUrl,
} from 'api/utils'
import dayjs from 'dayjs'
import { useCurrentUrl } from 'hooks/useCurrentUrl'
import { useRouterExtend } from 'hooks/useRouterExtend'
import {
  API_DAYJS_FORMAT,
  basePath,
  HEALTH_TOOL_TYPE,
  QUERY_HEALTH_TOOL,
} from 'interfaces/constants'
import { BabyVaccinationContent } from 'interfaces/types/BabyVaccination'
import { AppContext } from 'state/appContext'

export const BabyVaccination = (props: BoxProps) => {
  const [data, setData] = useState<BabyVaccinationContent | null>(null)
  const currentUrl = useCurrentUrl()
  const { locale = 'vi-VN', router } = useRouterExtend()
  const {
    state: { isLoggedIn },
  } = useContext(AppContext)

  const { getHealthToolLink } = useHealthToolsCache(locale + '_MB')

  const toolLink = useMemo(
    () => getHealthToolLink(HEALTH_TOOL_TYPE.BABY_VACCINE),
    [getHealthToolLink],
  )

  const onSubmit = (values: any) => {
    const { gender = '' } = values
    const age = dayjs(values.age).format(API_DAYJS_FORMAT)
    ;(async () => {
      const redirectPageUrl = toolLink

      const destination = `${
        typeof window !== 'undefined' ? window.location.origin : ''
      }${basePath}${redirectPageUrl}?${
        QUERY_HEALTH_TOOL.gender
      }=${formatGenderUrl(gender)}&${QUERY_HEALTH_TOOL.age}=${age}`
      if (!isLoggedIn) {
        redirectToSSOWithReturnUrl(destination, 'baby-vaccine')
      } else {
        router.push(destination)
      }
    })()
  }

  useEffect(() => {
    ;(async () => {
      const res = await callApi(
        getApiPath(PATHS.GET_HEALTH_TOOL_BABY_VACCINE_INFO),
        'GET',
      )
      setData(
        () => formatBabyVaccinationContent(res?.data) as BabyVaccinationContent,
      )
    })()
  }, [])

  if (!toolLink)
    return (
      <div
        style={{
          height: 300,
        }}
      />
    )

  return (
    <BabyVaccineCardEmbed
      babyVaccineContent={data}
      formProps={
        {
          formLayout: 'default',
          onSubmit,
          submitProps: {
            dataEventLabel: currentUrl,
          },
        } as any
      }
      {...props}
    />
  )
}
